import React, {Component} from "react"
import {observer, action, observable} from "mobx-react"
import {Grid, Image} from "semantic-ui-react"
import {Link} from "react-router-dom"
import app from "app.controller"
import shop from "shop/shop"

// import "./TopNavigation.scss"

@observer
export default class CategoriesGrid extends Component {

  state = {
    menu:    false,
    current: false
  }

  render() {
    const { categories } = shop.store.categories

    return (
      <div className="CategoriesGrid">
        <Grid columns={4} doubling stackable>
          {categories.map( category => <Category key={category.map_id} category={category}/> )}
        </Grid>
      </div>
    )
  }
}

const Category = ({ category }) => {
  return (
      <Grid.Column>
       <div className="pt4">
         <Link to={`/collection/${category.map_id}`} >
           <img className="mw-100" src={category.img_src}/>
         </Link>
       </div>
      </Grid.Column>
  )
}



// WEBPACK FOOTER //
// ./src/components/Category/CategoriesGrid.js